define([
	'jquery',
	'Handlebars',
	'shared.main.screen'
	], function($, Handlebars, screenSize) {

	'use strict';
	var DEBUG = false;

	if ( DEBUG ) console.log('facets helpers');
	
	Handlebars.registerHelper('sortCheck', function (sortSelectionState, sortLabel) {

		if ( sortLabel === sortSelectionState) {
			return 'checked';
		}

	});

	Handlebars.registerHelper('facetsActiveFiltersDisplayOpen', function ( state, selectedFacets ) {

		if ( state.numActive > 0 && state.renderedActive === 0 || state.isFirstLoad === true ) {
			return 'animate-open';
		}

	});

	Handlebars.registerHelper('facetsNewActiveAnimationClass', function( state, label ) {

		if ( typeof state.newActive !== 'undefined' && state.newActive.indexOf(label) !== -1 ) {
			return 'animate-add';
		}

	});

	Handlebars.registerHelper('facetsActiveOptionHideClass', function ( options ) {
		var hideClass = 'hidden';
		options.forEach(function(option){
			if ( option.active === true ) {
				hideClass = '';
			}
		});
		return hideClass;
	});

	Handlebars.registerHelper('facetsSmallScreenActive', function (options) {

		var numActive = 0, 
			active = '';

		// get number of active options
		options.map(function(option){
			if ( option.active ) {
				numActive++;
			}
			return option;
		}).forEach(function(option, index){
			if ( option.active ) {
				active += option.label;
				numActive--;
			}

			if ( numActive > 0 && option.active ) {
				active += ', ';
			}

		});

		return active;
		
	});

	Handlebars.registerHelper('smallScreenStartDiv', function (type, filterMenuOpen, isOffCanvas) {
		
		var hiddenClass = (isOffCanvas) ? '' : 'hidden';

		if ( ['small', 'medium'].indexOf(screenSize.size()) === -1 ) {
			return;
		}

		if ( filterMenuOpen && type !== 'SORT' ) {
			return '<div class="filter-mobile-container ' + hiddenClass + ' ' + type.toLowerCase().replace(":", "") + '" data-filter-type="'+type+'">';
		}

		return '<div class="filter-mobile-container ' + hiddenClass + ' ' + type.toLowerCase().replace(":", "") + '" data-filter-type="'+type+'">';

	});

	Handlebars.registerHelper('smallScreenEndDiv', function () {

		if ( ['small', 'medium'].indexOf(screenSize.size()) === -1 ) {
			return;
		}

		return '</div>';

	});

	Handlebars.registerHelper('smallScreenShowOnly', function () {
		
		if ( ['small', 'medium'].indexOf(screenSize.size()) === -1 ) {
			return ' hidden';
		}
		
	});

	Handlebars.registerHelper('mediumScreenColumns', function (facets) {
		
		// accounting for number of facets + the sort column - need equal columns for the layout
		var mediumScreenColumnsClass;
		
		switch ( facets.length ) {

			case 1 :

				mediumScreenColumnsClass = 'medium-6';
				break;

			case 2 :

				mediumScreenColumnsClass = 'medium-4';
				break;

			case 3 :

				mediumScreenColumnsClass = 'medium-3';
				break;

			// special class name for when there are 4 facets - need to account for 5 equal columns
			case 4 :

				mediumScreenColumnsClass = 'medium-1-of-5';
				break;

			case 5 :

				mediumScreenColumnsClass = 'medium-2';
				break; 
		
		}

		return mediumScreenColumnsClass;
		
	});
		
// begin define close		
});
// end define close